import React, { useState,useEffect } from 'react';
import { IonGrid,IonRow,IonCol, IonList,IonLabel,IonButton, IonItem,IonRange,IonCheckbox, IonText } from '@ionic/react';


interface ContainerProps {
  title: string;
  description: string;
  name: string;
min:number;
max:number;
desconocida:string;
defaultValue:number;
step:number;
hideparams:number;
handler:(value:number)=>void;
}
const customFormatter = (value: number) => `${value}`;

const ControlFE: React.FC<ContainerProps> = ({ hideparams,title,description,desconocida,min,max,defaultValue,step,handler }) => {
  const [value, setValue] = useState(defaultValue);
  const [esdesconocida, setEsDesconocida] = useState(0);

  useEffect(() => {
    if(esdesconocida===1){
      handler(101);
    }else{
      handler(value);
    }
      
  }, [value,esdesconocida]);

  if(hideparams===1) return(<></>);
  else
  return (
      <IonList>
            <IonGrid>

<IonRow className="ion-justify-content-start">
    <IonCol size='auto'>
    <div  className="ParamDetailValue" style={{textAlign:"center"}}>
          <IonButton color="light" size="small"  className="pl1">
            {esdesconocida===1?"??":value}
          </IonButton>
              </div>
    </IonCol>
    <IonCol>
    <div  className="ParamDetail" style={{height:"36px",textAlign:"left"}}>
<IonText className='f1 strong'>{title}: {description}</IonText></div>
    </IonCol>
</IonRow>
</IonGrid>




          <IonRow >
            <IonCol size="6">
                        <IonItem lines="none"  style={{paddingTop:"0em"}}>
          {esdesconocida===0?<IonRange className="ion-no-padding" style={{height:"24px"}} value={value} min={min} max={max} step={step} snaps={true} ticks={false}
                  onIonChange={e => setValue(e.detail.value as number)}
                  pinFormatter={customFormatter} 
              >
              </IonRange>:''}
              
          </IonItem>
            </IonCol>
            <IonCol size="6">
            <IonItem lines="none" className=" f1"  style={{paddingTop:"0em",paddingleft:"2em", textAlign:"left"}}>
            <IonCheckbox  checked={esdesconocida===1} onIonChange={e => setEsDesconocida(e.detail.checked?1:0)} >
              
            </IonCheckbox>
            <IonLabel>&nbsp;&nbsp;{desconocida}</IonLabel>
            </IonItem>
            </IonCol>
          </IonRow>


      </IonList>
);
};


export default ControlFE;
